import { Providers } from '@/components/app/Providers';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';

import { AnalyticsPage } from '@/pages/analytics';
import { AppVersionsPage } from '@/pages/app-versions';
import { BusinessesPage } from '@/pages/businesses';
import { CategoriesPage } from '@/pages/categories';
import { Dashboard } from '@/pages/dashboard';
import { EventReportPage } from '@/pages/event-report';
import { FiltersPage } from '@/pages/filters';
import { ImportPage } from '@/pages/import';
import { NotificationsPage } from '@/pages/notifications';
import { UsersPage } from '@/pages/users';

export const App = () => {
  const location = useLocation();

  // Don't redirect if this is an Auth0 callback (has code or error params)
  const isAuth0Callback =
    location.search.includes('code=') || location.search.includes('error=');

  return (
    <Providers>
      <Routes>
        <Route
          path='/'
          element={
            isAuth0Callback ? (
              <Dashboard />
            ) : (
              <Navigate to='/dashboard' replace />
            )
          }
        />
        <Route path='/dashboard' element={<Dashboard />} />
        <Route path='/analytics' element={<AnalyticsPage />} />
        <Route path='/users/:id?' element={<UsersPage />} />
        <Route path='/businesses/:id?' element={<BusinessesPage />} />
        <Route path='/categories/:id?' element={<CategoriesPage />} />
        <Route path='/filters/:id?' element={<FiltersPage />} />
        <Route path='/import' element={<ImportPage />} />
        <Route path='/notifications' element={<NotificationsPage />} />
        <Route path='/app-versions/:id?' element={<AppVersionsPage />} />
        <Route path='/event-report' element={<EventReportPage />} />
      </Routes>
    </Providers>
  );
};
